// extracted by mini-css-extract-plugin
export default {"coupon":"CouponInput_coupon__z0z9U"};